import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        backgroundColor: scrolled ? 'rgba(26,26,26,0.97)' : 'rgba(26,26,26,0.5)',
        backdropFilter: 'blur(8px)',
        borderBottom: scrolled ? '1px solid rgba(245,166,35,0.2)' : 'none',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        {/* Logo */}
        <a
          href="/"
          className="flex items-center gap-2 cursor-pointer"
          aria-label="Kaba baba トップへ"
        >
          <img src="/logo-icon.png" alt="baba Kaba アイコンロゴ" className="h-8 w-8 object-contain" />
          <span
            className="text-2xl font-black tracking-wider"
            style={{ color: '#f5a623', fontFamily: '"Oswald", sans-serif' }}
          >
            baba Kaba
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          {[
            { label: '特徴・強み', id: 'features' },
            { label: 'サービス', id: 'inventory' },
            { label: '会社概要', id: 'about' },
            { label: '店舗情報', id: 'shop-info' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-medium text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              {item.label}
            </button>
          ))}
          <a
            href="tel:08097798744"
            className="flex items-center gap-2 px-4 py-2 rounded font-bold text-sm whitespace-nowrap transition-all duration-200 hover:opacity-90"
            style={{
              backgroundColor: '#f5a623',
              color: '#1a1a1a',
              fontFamily: '"Noto Sans JP", sans-serif',
            }}
          >
            <i className="ri-phone-fill"></i>
            <span>080-9779-8744</span>
          </a>
        </nav>

        {/* Mobile menu button */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニューを開く"
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-3-line text-2xl'}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div
          className="md:hidden border-t py-4 px-4"
          style={{
            backgroundColor: 'rgba(26,26,26,0.98)',
            borderColor: 'rgba(245,166,35,0.2)',
          }}
        >
          {[
            { label: '特徴・強み', id: 'features' },
            { label: 'サービス', id: 'inventory' },
            { label: '会社概要', id: 'about' },
            { label: '店舗情報', id: 'shop-info' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="block w-full text-left py-3 text-white/80 hover:text-white border-b border-white/10 cursor-pointer"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              {item.label}
            </button>
          ))}
          <a
            href="tel:08097798744"
            className="flex items-center justify-center gap-2 mt-4 py-3 rounded font-bold"
            style={{ backgroundColor: '#f5a623', color: '#1a1a1a', fontFamily: '"Noto Sans JP", sans-serif' }}
          >
            <i className="ri-phone-fill"></i>
            080-9779-8744
          </a>
        </div>
      )}
    </header>
  );
}